import { render, staticRenderFns } from "./Apartment.vue?vue&type=template&id=fd31a52a&scoped=true"
import script from "./Apartment.vue?vue&type=script&lang=js"
export * from "./Apartment.vue?vue&type=script&lang=js"
import style0 from "./Apartment.vue?vue&type=style&index=0&id=fd31a52a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd31a52a",
  null
  
)

export default component.exports